import React from "react";
import { CardActionOption } from "../../components/cardActionOption";

import {
  Container,
  Content,
  OptionsWrapper,
  // PixHelpMeIcon,
  PixIcon,
  PixMyKeysIcon,
} from "./styles";

export const PixOptions = () => {
  return (
    <Container>
      <Content>
        <OptionsWrapper>
          <CardActionOption linkTo="/pix/transfer" Icon={PixIcon} title={`Transferir`} />
          <CardActionOption linkTo="/pix/copiaecola" Icon={PixIcon} title={"Copia e Cola"} />
          <CardActionOption
            linkTo="mykeys"
            Icon={PixMyKeysIcon}
            title={"Minhas chaves"}
          />
        </OptionsWrapper>
      </Content>
    </Container>
  );
};
